import React, { Component, Fragment } from 'react';
import { GROUP_TYPE, PRODUCT_LIST_TYPE, UserProductGroup } from '~/Api/User/ProductGroup';
import ProductFilterForm from '~/ProductFilterForm';
import { CreateModal as ProductGroupCreateModal } from '~/ProductGroup';
import ProductGroupList from '~/ProductGroupList/GroupList/GroupListContainer';
import Button from '~/UI/Button';
import primaryAltSmallButtonStyles from '~/UI/Button/primary-alt-small.less';
import secondarySmallButtonStyles from '~/UI/Button/secondary-small.less';
import Heading from '~/UI/Heading/Heading';

import type { ProductFilterFormFilters } from '~/ProductFilterForm/ProductFilterForm';

import styles from './styles.less';
import { FilterOperator } from '~/Api/Product/Query';

export interface Access {
	analytics: boolean;
	search: boolean;
	productGroups: boolean;
}

interface Props {
	scrollOnList: boolean;
	defaultFilterParameters: ProductFilterFormFilters;
	access: Access | null;
	onSearch(parameter: ProductFilterFormFilters, operator: FilterOperator | null, date?: Date | null): void;
	onGroupCreated(group: UserProductGroup): void;
}

interface State {
	filterParameters: ProductFilterFormFilters | null;
	createGroupType: typeof PRODUCT_LIST_TYPE | typeof GROUP_TYPE | null;
	filterOperator: FilterOperator | null;
}

export default class ListPage extends Component<Props, State> {
	headerElement: HTMLDivElement | null = null;

	productGroupListElement: HTMLDivElement | null = null;

	scrolled = false;

	state: State = {
		filterParameters: null,
		createGroupType: null,
		filterOperator: null,
	};

	componentDidMount() {
		if (this.props.scrollOnList) {
			this.scrollOnList();
		}
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.scrollOnList !== this.props.scrollOnList) {
			if (this.props.scrollOnList) {
				this.scrollOnList();
			} else {
				this.scrollOnHeader();
			}
		}
	}

	scrollOnHeader() {
		if (this.headerElement) {
			this.headerElement.scrollIntoView(true);
		}
	}

	scrollOnList() {
		if (this.productGroupListElement) {
			this.productGroupListElement.scrollIntoView(true);
		}
	}

	render() {
		const {
			props: { access, onSearch, onGroupCreated },
			state: { filterParameters, createGroupType, filterOperator },
		} = this;

		const activeFilterParamters = filterParameters || this.props.defaultFilterParameters;

		return (
			<section className={styles.section}>
				{access?.search ? (
					<div className={styles.header} ref={(ref) => (this.headerElement = ref)}>
						<div className={styles.in}>
							<ProductFilterForm
								filterParameters={activeFilterParamters}
								filterOperator={filterOperator ? filterOperator : FilterOperator.and}
								key='group-list'
								onChange={(changeParameters, operator) =>
									this.setState({ filterParameters: changeParameters, filterOperator: operator })
								}
								onSearch={(searchParameters, operator) => onSearch(searchParameters, operator)}
							/>
						</div>
					</div>
				) : null}

				{access?.productGroups ? (
					<Fragment>
						<div className={styles.list} ref={(ref) => (this.productGroupListElement = ref)}>
							<div className={styles.in}>
								<Heading>Product List</Heading>
								<div className={styles.buttonsPanel}>
									<Button
										disabled={!access}
										styles={primaryAltSmallButtonStyles}
										onClick={() => this.setState({ createGroupType: GROUP_TYPE })}
									>
										Create folder
									</Button>
									<Button
										disabled={!access}
										styles={secondarySmallButtonStyles}
										onClick={() => this.setState({ createGroupType: PRODUCT_LIST_TYPE })}
									>
										Create list
									</Button>
								</div>
							</div>
							<ProductGroupList showModule parentId={null} onFetched={this.handleGroupsFetched} />
						</div>

						{createGroupType !== null ? (
							<ProductGroupCreateModal
								groupType={createGroupType}
								onClose={this.closePopover}
								onSave={onGroupCreated}
							/>
						) : null}
					</Fragment>
				) : null}
			</section>
		);
	}

	closePopover = () => {
		this.setState({ createGroupType: null });
	};

	handleGroupsFetched = () => {
		if (!this.scrolled && this.props.scrollOnList) {
			this.scrolled = true;
			this.scrollOnList();
		}
	};
}
